import { useSyncExternalStore } from 'react';
import { useI18n } from 'shared/lib/i18n.tsx';
import {
  getCalibrationAlertSnapshot,
  subscribeCalibrationAlert,
} from '../../state/calibrationAlertStore.ts';

const CONFIG = {
  DARK: {
    variant: 'calibration-alert--dark',
    icon: '/icons/ic_moon.svg',
    titleKey: 'calib.dark.title',
    subKey: 'calib.dark.sub',
  },
  BRIGHT: {
    variant: 'calibration-alert--bright',
    icon: '/icons/ic_sun.svg',
    titleKey: 'calib.bright.title',
    subKey: 'calib.bright.sub',
  },
  LOW_CONF: {
    variant: 'calibration-alert--low-conf',
    icon: '/icons/ic_eye_off.svg',
    titleKey: 'calib.low_conf.title',
    subKey: 'calib.low_conf.sub',
  },
} as const;

/**
 * Calibration / preparation-screen alert, shown top-center for every game **except catch-pose**.
 * Driven by the shared store, which display engines set from `frame.calibration`.
 */
export function CalibrationAlert() {
  const { t } = useI18n();
  const kind = useSyncExternalStore(
    subscribeCalibrationAlert,
    getCalibrationAlertSnapshot,
    getCalibrationAlertSnapshot,
  );

  if (kind === null) return null;

  const cfg = CONFIG[kind];

  const maskStyle = {
    maskImage: `url(${cfg.icon})`,
    WebkitMaskImage: `url(${cfg.icon})`,
  };

  return (
    <div className={`calibration-alert ${cfg.variant}`} role="status" aria-live="polite">
      <div className="calibration-alert__icon">
        <span className="calibration-alert__glyph" style={maskStyle} aria-hidden="true" />
      </div>
      <div className="calibration-alert__text">
        <div className="calibration-alert__title">{t(cfg.titleKey)}</div>
        <div className="calibration-alert__sub">{t(cfg.subKey)}</div>
      </div>
    </div>
  );
}
